import { nanoid } from "nanoid";

/**
 * Generates a unique ID string prefixed with 'wc-' to avoid starting with a number.
 */
export const GetUniqueId = (): string => {
  // prefix is because nanoid can start with a number that is not allowed on id attribute
  return `wc-${nanoid(10)}-${Date.now()}-${Math.floor(Math.random() * 100)}`;
};

/**
 * Generates a simple hash code from a given string.
 * @param toHash - The string to hash
 * @returns A 32-bit integer hash
 */
export const GetHashFromString = (toHash: string): number => {
  let hash = 0;
  if (toHash.length === 0) return hash;
  for (let i = 0; i < toHash.length; i++) {
    const chr = toHash.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
